import Promise from 'bluebird';
import _ from 'lodash';

import api from '../../api';
import ColorBrewer from '../../core/tools/colorbrewer';
import environment from '../../environment';
import ShapesAfterSalesControl from './ShapesAfterSalesControl';
import { Constants } from '../../../constants/constants';

const _getMarkedAreaThemes = () => {
    const markedThemes = (environment.get('CONFIG.FILTERS.MARKED_AREA_THEMES') || []);
    return markedThemes;
};

export class MarkedAreaAfterSalesControl extends ShapesAfterSalesControl {
    constructor() {
        const options = {
            id: 'operational-area',
            name: 'MarkedAreaAfterSales',
            types: environment.get('CONFIG.FILTERS.MARKED_AREA_TYPES'),
            themes: _getMarkedAreaThemes(),
            request: api.afterSales.get.themes,
            filter: true,
            overview: true
        };

        super(options);
        this.colorize = this.colorize.bind(this);
    }

    static getInstance() {
        if (!MarkedAreaAfterSalesControl._instance) {
            MarkedAreaAfterSalesControl._instance = new MarkedAreaAfterSalesControl();
        }

        return MarkedAreaAfterSalesControl._instance;
    }

    colorize(featureCollection, layer) {
        return new Promise(resolve => {

            super.colorize(featureCollection, layer)
                .then(res => {
                    this.setThemeLayerOptions();
                    resolve(res);
                });
        });
    }

    setThemeLayerOptions() {
        const options = this.getLayer().options;
        this.getControls().colorpicker.fillColor.input.enable(true);
        this.getControls().colorpicker.fillColor.enable = true;
        options.symbology.scale = 'jenks';
        options.symbology.theme = ColorBrewer.OrRd[9];
        this.getLayer().setOptions(options);
    }
}

export default MarkedAreaAfterSalesControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/AfterSales/MarkedAreaAfterSalesControl.js